import {
  LayoutDashboard, Building2, HardHat, Users, ClipboardList, Clock, Wallet, FileBarChart,
  FileText, Receipt, ShoppingCart, Landmark, CalendarDays, Bot, Settings, Home, Timer, History, User,
} from "lucide-react";

// Admin modules. `ready` modules have real screens; the rest render the Coming soon state.
export const ADMIN_NAV = [
  { group: "operations", items: [
    { key: "dashboard", path: "/admin", icon: LayoutDashboard, ready: true },
    { key: "clients", path: "/admin/clients", icon: Building2 },
    { key: "projects", path: "/admin/projects", icon: HardHat },
    { key: "employees", path: "/admin/employees", icon: Users, ready: true },
    { key: "assignments", path: "/admin/assignments", icon: ClipboardList },
    { key: "time_tracking", path: "/admin/time-tracking", icon: Clock },
    { key: "calendar", path: "/admin/calendar", icon: CalendarDays },
  ]},
  { group: "finance", items: [
    { key: "payroll", path: "/admin/payroll", icon: Wallet },
    { key: "labor_reports", path: "/admin/labor-reports", icon: FileBarChart },
    { key: "estimates", path: "/admin/estimates", icon: FileText },
    { key: "invoices", path: "/admin/invoices", icon: Receipt },
    { key: "expenses", path: "/admin/expenses", icon: ShoppingCart },
    { key: "payments", path: "/admin/payments", icon: Landmark },
  ]},
  { group: "tools", items: [
    { key: "ai_assistant", path: "/admin/ai-assistant", icon: Bot },
    { key: "settings", path: "/admin/settings", icon: Settings, ready: true },
  ]},
];

export const ADMIN_MODULES = ADMIN_NAV.flatMap((g) => g.items);
export const COMING_SOON_MODULES = ADMIN_MODULES.filter((m) => !m.ready);

export const EMPLOYEE_NAV = [
  { key: "home", path: "/portal", icon: Home },
  { key: "clock", path: "/portal/clock", icon: Timer },
  { key: "hours", path: "/portal/hours", icon: History },
  { key: "earnings", path: "/portal/earnings", icon: Wallet },
  { key: "profile", path: "/portal/profile", icon: User },
];
